module.exports = __webpack_public_path__ + "7db8ef2494d291df5652ccd769557a99.png";